import { useCallback, useState } from 'react';
import { ApiService, CompaniesByFirm } from 'api';
import { ERROR_404 } from 'common/config/api';
import { useResponse } from 'services/hooks/useResponse';

export type CompaniesListStatus = 'loading' | 'loaded' | 'error';

export const useGetCompaniesFromPreviousMD = () => {
  // Starts as loading so nothing can be created before the first response.
  const [status, setStatus] = useState<CompaniesListStatus>('loading');
  const [companies, setCompanies] = useState<CompaniesByFirm[]>([]);
  const { processErrorResponse } = useResponse();

  const getCompanies = useCallback(
    async (firmId: number) => {
      if (!firmId) {
        return;
      }
      setStatus('loading');
      try {
        setCompanies((await ApiService.apiFirmsCompaniesListList(firmId.toString())) ?? []);
        setStatus('loaded');
      } catch (error) {
        setCompanies([]);
        setStatus('error');
        processErrorResponse({
          error,
          defaultErrorMessage: 'An error occurred while loading Companies',
          action: 'get companies',
          // A firm without companies answers 404: an empty list, not a failure.
          config: { [ERROR_404]: { notification: false, callback: () => setStatus('loaded') } },
        });
      }
    },
    [processErrorResponse]
  );

  return { companies, getCompanies, status };
};
